import { inject, Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { TranslateService } from '@ngx-translate/core';
import { switchMap } from 'rxjs/operators';
import { AppsyncGetPharmacyService } from '../../../../../../libs/common/services/src/appsync/appsync-get-pharmacy.service';
import { loadPharmacy, loadPharmacyError, setPharmacy } from '../actions/pharmacy.actions';

@Injectable()
export class PharmacyEffects {
  private actions$ = inject(Actions);
  private appsyncGetPharmacyService = inject(AppsyncGetPharmacyService);
  private translate = inject(TranslateService);

  loadPharmacy$ = createEffect(() =>
    this.actions$.pipe(
      ofType(loadPharmacy),
      switchMap(async ({ pharmacyId }) => {
        try {
          const pharmacy = await this.appsyncGetPharmacyService.getPharmacyFromBackend(pharmacyId);
          if (pharmacy) {
            return setPharmacy({ pharmacy });
          } else {
            return loadPharmacyError();
          }
        } catch (err) {
          const errorMessage = 'FAILED_TO_LOAD_PHARMACY';
          console.warn(this.translate.instant(errorMessage), err);
          return loadPharmacyError();
        }
      })
    )
  );
}
